import { Component, OnInit, HostListener } from "@angular/core";
import { Router } from '@angular/router';
import { Consultant } from "../../../models/Consultant.model";
import { ConsultantService } from "../../../services/consultant.service";
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { Json2csvService } from "../../../services/json2csv.service";
import * as moment from 'moment';
import * as _ from 'lodash';
import { ConsultantFilterFactory } from "../../../shared/factories/consultants/filters.factory";
import { LocalStorage } from "../../../shared/wrappers/LocalStorage";
import { UrlBuilderFactory } from "../../../shared/factories/url-builder.factory";
import { ToastsManager } from "ng2-toastr";
import { GUARDS } from '../../../shared/auth/Roles';
import { DropDownList } from '../../../models/DropDownList.model';
import { BankService } from '../../../services/bank.service';

interface CustomerType {
    _id?: string
    end: string
    start: string
    name: string
    managerClient: string
}

interface Signer {
    name: string;
    email: string;
    type: string,
    order: number;
    signed: boolean;
}

@Component({
    selector: "app-consultants",
    templateUrl: "./consultants-report.component.html",
    styleUrls: ["./consultants-report.component.css"],
})
export class ConsultantsReportComponent implements OnInit {

    filters = {
        active: { list: [], options: null, selected: [] },
        customerActive: { list: [], options: null, selected: [] },
        kind: { list: [], options: null, selected: [] },
        responsible: { list: [], options: null, selected: [] },
        customer: { list: [], options: null, selected: [] },
        skill: { list: [], options: null, selected: [] },
        name: null,
        email:null,
        month: { list: [], selected: null },
        monthend: { list: [], selected: null },
        limit: { list: [5, 10, 50, 100], selected: 10 },
        year: { list: [], selected: null },
        yearend: { list: [], selected: null },
        additivePending: { list: [], options: null, selected: [] },
        skip: 0,
        industry: { list: [], options: null, selected: [] },
        excellenceCenter: { list: [], options: null, selected: [] },
        supportCenter: { list: [], options: null, selected: [] },
    };

    consultants: Consultant[];
    banks;
    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 0;
    currentPage: number = 0;
    skip:number = 0;
    limit:number = 10;
    loading:boolean;
    outputPersonal:boolean = false;
    outputContract:boolean = false;
    outputBorrowedNote: boolean = false;
    outputContractHistory:boolean = false;
    outputAdditiveHistory:boolean = false;
    outputPayment: boolean = false;
    outputContact: boolean = false;
    outputFinishedDocuments: boolean = false;
    currentSkip;
    currentLimit;
    occupations = [];
    user;
    canShow: boolean = false;
    isUserAdm2: boolean = false;
    isUserControllership: boolean = false;
    isUserInfra: boolean = false;
    isUserGovernance: boolean = false;
    isUserCommercial: boolean = false;
    isUserDP: boolean = false;
    isUserFinances: boolean = false;
    isUserJudiciary: boolean = false;
    isUserRS: boolean = false;
    isUserBP: boolean = false;
    isUserAccounting: boolean = false;
    isUserPeople = false;
    GUARDS = GUARDS;
    docuSignDocuments;
    privateCategory = [GUARDS.JUDICIARY, GUARDS.GOVERNANCE, GUARDS.MANAGER, GUARDS.COMMERCIAL];

    dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();
    centerIds;

    constructor(
        private consultantService: ConsultantService,
        private json2csvService: Json2csvService,
        private commonHelper:CommonHelper,
        private consultantFiltersFactory: ConsultantFilterFactory,
        private localStorage:LocalStorage,
        private queryStringFactory: UrlBuilderFactory,
        private toastr: ToastsManager,
        private bankService: BankService,
        private router: Router,
    ) {}

    async ngOnInit() {
        this.user = this.localStorage.retrieve('user');
        this.checkPermissions();

        if (this.privateCategory.includes(this.user.permission))
            this.canShow = true;
        this.filters = await this.consultantFiltersFactory.build(this.filters);
        this.centerIds = this.commonHelper.excellenceCenterIds();
        this.occupations = await this.consultantService.getAllContractProfile();
        this.banks = await this.bankService.getBanks();

        if(this.user.permission == GUARDS.TECHMANAGEMENT) {
            this.setIndustryForTechManagement();
        }

        this.searchConsultants();
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.searchConsultants(1);
        }

    }

    async searchConsultants(page?: number) {
        this.loading = true;
        this.currentPage = page ? page : 1;
        const res = await this.consultantService.getAll(this.queryStringFactory.build(this.loadFilters(page)));
        this.totalItems = res.metadata["totalItems"];
        this.consultants = res.data;
        this.loading = false;
    }

    saveFilters() {
        this.localStorage.save(this.loadFilters(), 'consultants');
    }

    loadFilters(page?) {
        this.currentPage = page ? page : (this.currentPage ? this.currentPage : 1);

        let filters = {};

        _.forOwn(this.filters, (value, key) => {
            const selected = _.get(value, 'selected', value);
            if (selected == 'undefined' || selected == null) return;

            filters[key] = selected;
            filters[key] = _.isArray(filters[key]) ? filters[key].map(item => _.get(item, 'id')) : filters[key];
        });

        return {
            ...filters,
            limit: this.filters.limit.selected,
            skip: (this.currentPage - 1) * this.filters.limit.selected
        };
    }

    async export() {
        this.loading = true;
        this.currentSkip = this.filters.skip;
        this.currentLimit = this.filters.limit.selected;
        this.filters.skip = 0;
        this.currentLimit = this.filters.limit.selected = 0;
        const res = await this.consultantService.getAll(this.queryStringFactory.build(this.loadFilters(1)));

        let consultantsExport = [];

        if(res.data && res.data.length && this.outputFinishedDocuments) {
            const consultantIds = res.data.map(consultant => consultant._id);
            this.docuSignDocuments = await this.consultantService.getAllDocusignDocuments(consultantIds);
        }

        //condition for order and mount csv header first
        if(this.isUserDP) {
           res.data.sort((a, b) => a.contract.kind == 2 ? -1 : 1)
        } else if(this.isUserRS) {
            res.data.sort((a, b) => a.supportCenter && a.supportCenter._id == this.centerIds.SGA ? 1 : -1)
        } else if(this.isUserBP) {
            res.data.sort((a, b) => a.bp && a.bp.name == this.user.name ? -1 : 1);
            res.data = res.data.filter( c => { c.bp
                if(c.bp){
                    return c.bp.name == this.user.name
                }
            });
        }

        consultantsExport = res.data.map(consultant => {
            let isUserDPAndCLT = this.isUserDP && consultant.contract.kind != 1;
            let consultantIsFromBP = this.isUserBP && consultant.bp && consultant.bp.name == this.user.name;
            const isConsultantNotSGAandUserRS = this.isUserRS && (!consultant.supportCenter || consultant.supportCenter._id !== this.centerIds.SGA);

            let exportObject = this.setExport(consultant);
            let format = this.setFormat(consultant,exportObject);

            if(this.outputPersonal){
                if(this.canShow || isUserDPAndCLT || consultantIsFromBP || isConsultantNotSGAandUserRS || this.isUserPeople){
                    format = this.addPersonal(format,exportObject,consultant);
                } else {
                    format = this.addPersonal(format,exportObject,{},true);
                    if(this.user.permission == GUARDS.ADMINISTRATIVE)
                        format['Dado_Apenas_Para_Controle_Interno_De_Quem_NÃO_Assinou'] = consultant.acceptedTerm ? 'Sim' : 'Não';
                }
            }

            if(this.outputContract){
                format = this.addContract(format,exportObject,consultant);
            }

            if(this.outputBorrowedNote && this.canShow && !this.isUserRS){
                format = this.addBorrowInvoiceNote(format, consultant)
            }

            if(this.outputPayment && (this.canShow || isUserDPAndCLT || this.isUserFinances || consultantIsFromBP || this.isUserAccounting || this.isUserPeople)){
                format = this.addPayment(format,consultant);
            }

            if(this.outputContact && (this.canShow || isUserDPAndCLT || consultantIsFromBP || this.isUserPeople)){
                format = this.addContact(format,exportObject,consultant);
            }

            if(this.isUserInfra){
                format = this.addInfraDatas(format,consultant);
            }

            if(this.isUserAdm2){
                format = this.addAdm2Datas(format, consultant);
            }

            if(this.isUserControllership){
                format = this.setFormatControllership(format, consultant);
            }

            if(this.isUserFinances || this.isUserAccounting || this.isUserPeople){
                format = this.addFinancesData(format, exportObject,consultant);
            }

            if((this.isUserJudiciary || this.isUserGovernance) && this.outputFinishedDocuments){
                format = this.addFinishedDocumentsData(format, consultant);
            }

            if(this.isUserGovernance)
                format['Data_Criação_Registro'] = consultant.created ? moment(consultant.created).utc().format("DD/MM/YYYY") : '-'

            return format;
        });

        if(this.outputContract && this.outputAdditiveHistory){
            consultantsExport = this.addAdditivesHistory(consultantsExport);
        }

        if(this.outputContract && this.outputContractHistory){
            consultantsExport = this.addContactsHistory(consultantsExport);
        }

        this.json2csvService.export(
            consultantsExport,
            `relatório de consultores - ${new Date().toLocaleDateString('pt-br')}`
        );

        this.filters.skip = this.currentSkip;
        this.filters.limit.selected = this.currentLimit;
        this.loading = false;
        this.toastr.success('Exportação de consultores realizada com sucesso.');

    }

    getStatus(status){
        switch (status){
            case false:
                return "Inativo";
            case true:
                return "Ativo";
        }
    }

    setFormat(consultant,exportObject){
        return {
            'Nome': consultant.name?consultant.name:"-",
            'Email_Nação_Digital': consultant.fcEmail?consultant.fcEmail:"-",
            'Responsavel': consultant.responsible && consultant.responsible.name?consultant.responsible.name:'-',
            'Business_Partner':consultant.bp&&consultant.bp.name?consultant.bp.name:'-',
            'Sexo_do_Consultor': this.transcriptSex(consultant.personal.sex),
            'Status':exportObject.status?exportObject.status:"-",
            'Contrato_Tipo':exportObject.kind?exportObject.kind:"-",
            'Centro_de_Excelencia': consultant.excellenceCenter && consultant.excellenceCenter.name ? consultant.excellenceCenter.name : "-",
            'Área_de_Suporte': consultant.supportCenter && consultant.supportCenter.name ? consultant.supportCenter.name : "-",
            'Data_Inicio': consultant.consultantStart? moment(consultant.consultantStart).utc().format("DD/MM/YYYY"): "-",
        };
    }

    transcriptSex(sexCode){
        switch(sexCode){
            case '1': return 'Feminino';
            case '2': return 'Masculino';
            case '3': return 'Não Binário';
            case '4': return 'Prefere Não Informar';
            default: return '-';
        }
    }

    transcriptCustomerHistory(customerHistory: CustomerType){
        if(customerHistory.end != null){
            let dateStart = customerHistory.start ? moment(customerHistory.start).format('DD/MM/YYYY') : '';
            let dateEnd = customerHistory.end ? moment(customerHistory.end).format('DD/MM/YYYY') : '';
            return `${customerHistory.name} ${dateStart ? `- Inicio: ${dateStart}` : '' } ${dateEnd ? `- Fim: ${dateEnd}` : '' }`;
        }
    }

    transcriptCustomerName(customerName: CustomerType){
        if(customerName.end == null){
                return `${customerName.name}`;
        }
    }

    transcriptManagerClient(customerName: CustomerType){
        if(customerName.end == null)
            return `${customerName.name? customerName.name : ''} - ${customerName.managerClient? customerName.managerClient: 'gestor não definido'}`;
    }

    transcriptOldManagerClient(customerName: CustomerType){
        if(customerName.end != null){
            return `${customerName.name? customerName.name : ''} - ${customerName.managerClient? customerName.managerClient:'gestor não definido'}`;
        }
    }

    setExport(exportObject){
        return  {
            kind : this.commonHelper.transcriptContractType(exportObject.contract.kind),
            hono : this.commonHelper.transcriptHonorariumType(exportObject.contract.honorarium),
            status : this.getStatus(exportObject.active),
            born : exportObject.personal.born ? moment(exportObject.personal.born).utc().format("DD/MM/YYYY") : "-",
            civilStatus : exportObject.personal.civilStatus?this.commonHelper.transcriptCivilStatus(exportObject.personal.civilStatus):'-',
            begin : exportObject.contract.begin ? moment(exportObject.contract.begin).utc().format("DD/MM/YYYY") : "-",
            end : exportObject.contract.end ? moment(exportObject.contract.end).utc().format("DD/MM/YYYY") : "-",
            paymentType : exportObject.contract.paymentType? this.commonHelper.transcriptPaymentType(exportObject.contract.paymentType):'-',
            contractStatus : exportObject.contract.contractStatus? this.commonHelper.transcriptContractStatus(exportObject.contract.contractStatus):'-',
            contactType : exportObject.emergency.type? this.commonHelper.transcriptContactType(exportObject.emergency.type):'-',
            partnership : exportObject.contract.partnership?this.commonHelper.transcriptPartnershipType(exportObject.contract.partnership):'-'
        };
    }

    addPersonal(format,exportObject,consultant, setEmpty?){
        if(setEmpty) {
            const personalFields = [
                'RG',
                'CPF',
                'Nome_Mae',
                'Nome_Pai',
                'Termo_Confidencial_Gerado',
                'Dado_Apenas_Para_Controle_Interno_De_Quem_NÃO_Assinou',
                'Estado_Civil',
                'Data_Saída',
                'Email',
                'Data_Nascimento',
                'Telefone',
                'Celular',
                'Consultor_CEP',
                'Consultor_Endereco',
                'Consultor_Numero',
                'Consultor_Complemento',
                'Consultor_Bairro',
                'Consultor_Cidade','Consultor_Estado','Consultor_Pais'
            ]
            personalFields.forEach(field => format[field] = '-');
            return format;
        }

        if (!this.isUserRS) {
            format['RG'] = consultant.personal.rg?consultant.personal.rg:'-';
            format['CPF'] = consultant.personal.cpf?consultant.personal.cpf:'-';
            format['Nome_Mae'] = consultant.personal.motherName?consultant.personal.motherName:'-';
            format['Nome_Pai'] = consultant.personal.fatherName?consultant.personal.fatherName:'-';
            format['Termo_Confidencial_Gerado'] = consultant.generatedConfidentiality?'Sim':'Não';
            format['Dado_Apenas_Para_Controle_Interno_De_Quem_NÃO_Assinou'] = consultant.acceptedTerm?'Sim':'Não';
            format['Estado_Civil'] = exportObject.civilStatus;
            format["Data_Saída"] = consultant.consultantEnd ? moment(consultant.consultantEnd).utc().format("DD/MM/YYYY") : "-";
        } else {
            format["Data_Saída"] = consultant.consultantEnd ? moment(consultant.consultantEnd).utc().format("DD/MM/YYYY") : "-";
        }

        format['Email'] = consultant.email ? consultant.email : '-';
        format['Data_Nascimento'] = exportObject.born;
        format['Telefone'] = consultant.personal.homePhone?consultant.personal.homePhone:'-';
        format['Celular'] = consultant.personal.cellPhone?consultant.personal.cellPhone:'-';
        format['Consultor_CEP'] = consultant.personal.cep?consultant.personal.cep:'-';
        format['Consultor_Endereco'] = consultant.personal.address?consultant.personal.address:'-';
        format['Consultor_Numero'] = consultant.personal.number?consultant.personal.number:'-';
        format['Consultor_Complemento'] = consultant.personal.complement?consultant.personal.complement:'-';
        format['Consultor_Bairro'] = consultant.personal.district?consultant.personal.district:'-';
        format['Consultor_Cidade'] = consultant.personal.city?consultant.personal.city:'-';
        format['Consultor_Estado'] = consultant.personal.state && consultant.personal.state != 0 ? consultant.personal.state:'-';
        format['Consultor_Pais'] = consultant.personal.country?consultant.personal.country:'-';

        return format;
    }

    addContract(format,exportObject,consultant){
        let isUserDPAndCLT = this.isUserDP && consultant.contract.kind != 1;
        let consultantIsFromBP = this.isUserBP && consultant.bp && consultant.bp.name == this.user.name;
        const isConsultantNotSGAandUserRS = this.isUserRS && (!consultant.supportCenter || consultant.supportCenter._id !== this.centerIds.SGA);

        const flatCustomer = consultant.contract.customers && consultant.contract.customers.map((ch: CustomerType) => this.transcriptCustomerName(ch))
            .filter((item: string) => typeof item === 'string');
        const flatOldCustomers = consultant.contract.customers && consultant.contract.customers.map((ch: CustomerType) => this.transcriptCustomerHistory(ch))
            .filter((item: string) => typeof item === 'string');
        const flatManagerClient = consultant.contract.customers && consultant.contract.customers.map((ch: CustomerType) => this.transcriptManagerClient(ch))
            .filter((item: string) => typeof item === 'string');
        const flatOldManagerClient = consultant.contract.customers && consultant.contract.customers.map((ch: CustomerType) => this.transcriptOldManagerClient(ch))
            .filter((item: string) => typeof item === 'string');

        if(this.outputContractHistory && (this.canShow || isUserDPAndCLT || consultantIsFromBP))
            format['Contrato_Situacao'] = 'Vigente/Último';

        if(this.outputAdditiveHistory && (this.canShow || isUserDPAndCLT || consultantIsFromBP)) {
            format['Aditivo_Situacao'] = 'Vigente no contrato';
            format['Aditivo_Tipo'] = 'Vigente no contrato';
            format['Aditivo_Pendente'] = 'Vigente no contrato';
            format['Aditivo_Data'] = 'Vigente no contrato';
        }

        if(this.canShow || isUserDPAndCLT || this.isUserPeople) {
            format['Contrato_Inicio'] = exportObject.begin;
            format['Contrato_Fim'] = exportObject.end;
            format['Contrato_Tipo'] = exportObject.kind?exportObject.kind:"-";
            format['Honorario'] = exportObject.hono?exportObject.hono:"-"; // 1 = aberto / 2 = fechado
            format['Pagamento_Tipo'] = exportObject.paymentType?exportObject.paymentType:'-';
            format['Total_Valor'] = consultant.contract.totalValue?consultant.contract.totalValue.toLocaleString("pt-BR"):'-';
            format['Horas_Mensais'] = consultant.contract.mensalHours?consultant.contract.mensalHours.toLocaleString("pt-BR"):'-'; // horas mensais de contrato
            format['Custo_Total_Provisões_e_Benefícios'] = consultant.contract.totalCostWithBenefits?consultant.contract.totalCostWithBenefits.toLocaleString("pt-BR"):'-'; //valor das horas vendidas
            format['Valor_Hora'] = consultant.contract.hourValue?consultant.contract.hourValue.toLocaleString("pt-BR"):'-';
            format['Valor_Horas_vendidas'] = consultant.contract.soldHourValue?consultant.contract.soldHourValue.toLocaleString("pt-BR"):'-'; //valor das horas vendidas
            format['Beneficios'] = consultant.contract.benefits?consultant.contract.benefits:'-';
            format['Parceria_Contabil'] = exportObject.partnership; //rational, etc
            format['Parceria_Contabil_Obs'] = consultant.contract.partnershipObs?consultant.contract.partnershipObs:'-'; //comentarios
            format['Contrato_Status'] = exportObject.contractStatus;
            format['CPOM'] = consultant.contract.cpom?consultant.contract.cpom:'-';
            format['ISS'] = consultant.contract.iss?consultant.contract.iss:'-';
            format['IRRF'] = consultant.contract.irrf?consultant.contract.irrf:'-';
            format['PCC'] = consultant.contract.pcc?consultant.contract.pcc:'-';
            format['Contrato_Gerado'] = consultant.contract.generated?'Sim':'Não';
            format['Contrato_Nota'] = consultant.contract.borrowedNote?this.commonHelper.transcriptBorrowNote(parseInt(consultant.contract.borrowedNote)):'-';
            format['Alocacao'] = consultant.contract.allocation?this.commonHelper.transcriptAllocationType(consultant.contract.allocation):'-';
            format['Clientes'] = consultant.contract.customers&&consultant.contract.customers.length>0 ? flatCustomer.join(' | '):'-';
            format['Classificacao'] = consultant.contract.classification?this.commonHelper.transcriptContractClassification(consultant.contract.classification):'-';
            format['Skills'] = consultant.skills&&consultant.skills.length>0?consultant.skills.map(sk => sk.name).join(', '):'-';
            format['Contrato_Regime'] = consultant.contract.taxRegime?consultant.contract.taxRegime:'-';
            format['Motivo_Saida'] = consultant.contract.termination?this.commonHelper.transcriptLeaveType(consultant.contract.termination.leaveType):'-';
            format['Observacoes'] = consultant.contract.termination?consultant.contract.termination.observation:'-';
            format['Laptop_Devolvido'] = consultant.contract.termination?consultant.contract.termination.laptopReturned?'Sim':'Não':'-';
            format['Acordo_Devolucao'] = consultant.contract.termination?consultant.contract.termination.returnAgreement?'Sim':'Não':'-';
            format['Descricao_Acordo'] = consultant.contract.termination?consultant.contract.termination.descReturnAgreement?consultant.contract.termination.descReturnAgreement:'-':'-';
            format['Laptop_Com_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopReturned?consultant.contract.termination.laptopHasBreakdown?'Sim':'Não':'-';
            format['Valor_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopHasBreakdown?consultant.contract.termination.damageValue?consultant.contract.termination.damageValue:'-':'-';
            format['Descrição_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopHasBreakdown?consultant.contract.termination.damageValueObservation?consultant.contract.termination.damageValueObservation:'-':'-';
        }

        format['Cargo'] = consultant.contract.position?this.commonHelper.transcriptPositionType(consultant.contract.position):'-';
        format['Perfil'] = consultant.contract.occupation?(this.occupations.find(occ => occ.code == consultant.contract.occupation) || {}).name:'-';
        format['Razao_Social'] = consultant.contract.companyName?consultant.contract.companyName:'-';
        format['CNPJ'] = consultant.contract.cnpj?consultant.contract.cnpj:'-';
        format['Empresa_CEP'] = consultant.contract.cep?consultant.contract.cep:'-';
        format['Empresa_Endereco'] = consultant.contract.address?consultant.contract.address:'-';
        format['Empresa_Numero'] = consultant.contract.number?consultant.contract.number:'-';
        format['Empresa_Bairro'] = consultant.contract.district?consultant.contract.district:'-';
        format['Empresa_Cidade'] = consultant.contract.city?consultant.contract.city:'-';
        format['Empresa_Estado'] = consultant.contract.state?consultant.contract.state:'-';

        if(this.canShow || isUserDPAndCLT || consultantIsFromBP || isConsultantNotSGAandUserRS || this.isUserPeople) {
            format['Contrato_Inicio'] = exportObject.begin;
            format['Contrato_Fim'] = exportObject.end;
            format['Total_Valor'] = consultant.contract.totalValue?consultant.contract.totalValue.toLocaleString("pt-BR"):'-';
            format['Horas_Mensais'] = consultant.contract.mensalHours?consultant.contract.mensalHours.toLocaleString("pt-BR"):'-'; // horas mensais de contrato
            format['Valor_Hora'] = consultant.contract.hourValue?consultant.contract.hourValue.toLocaleString("pt-BR"):'-';
            format['Valor_Horas_vendidas'] = consultant.contract.soldHourValue?consultant.contract.soldHourValue.toLocaleString("pt-BR"):'-'; //valor das horas vendidas
            format['Custo_Total_Provisões_e_Benefícios'] = consultant.contract.totalCostWithBenefits?consultant.contract.totalCostWithBenefits.toLocaleString("pt-BR"):'-'; //valor das horas vendidas
            format['Beneficios'] = consultant.contract.benefits?consultant.contract.benefits:'-';
            format['Alocacao'] = consultant.contract.allocation?this.commonHelper.transcriptAllocationType(consultant.contract.allocation):'-';
            format['Clientes'] = consultant.contract.customers&&consultant.contract.customers.length>0 ?flatCustomer.join(' | '):'-';
            format['Gestor do Cliente - Histórico'] = consultant.contract.customers&&consultant.contract.customers.length>0 ?flatOldManagerClient.join(' | '):'-';
            format['Gestor do Cliente - Atual'] = consultant.contract.customers&&consultant.contract.customers.length>0 ?flatManagerClient.join(' | '):'-';
            format['Skills'] = consultant.skills&&consultant.skills.length>0?consultant.skills.map(sk => sk.name).join(', '):'-';
            format['Classificacao'] = consultant.contract.classification?this.commonHelper.transcriptContractClassification(consultant.contract.classification):'-';

            if (!this.isUserRS && !this.isUserBP) {
                format['Honorario'] = exportObject.hono?exportObject.hono:"-"; // 1 = aberto / 2 = fechado
                format['Pagamento_Tipo'] = exportObject.paymentType?exportObject.paymentType:'-';
                format['Parceria_Contabil'] = exportObject.partnership; //rational, etc
                format['Parceria_Contabil_Obs'] = consultant.contract.partnershipObs?consultant.contract.partnershipObs:'-'; //comentarios
                format['Contrato_Status'] = exportObject.contractStatus;
                format['CPOM'] = consultant.contract.cpom?consultant.contract.cpom:'-';
                format['ISS'] = consultant.contract.iss?consultant.contract.iss:'-';
                format['IRRF'] = consultant.contract.irrf?consultant.contract.irrf:'-';
                format['PCC'] = consultant.contract.pcc?consultant.contract.pcc:'-';
                format['Contrato_Gerado'] = consultant.contract.generated?'Sim':'Não';
                format['Contrato_Nota'] = consultant.contract.borrowedNote?this.commonHelper.transcriptBorrowNote(parseInt(consultant.contract.borrowedNote)):'-';
                format['Contrato_Regime'] = consultant.contract.taxRegime?consultant.contract.taxRegime:'-';
                format['Motivo_Saida'] = consultant.contract.termination?this.commonHelper.transcriptLeaveType(consultant.contract.termination.leaveType):'-';
                format['Observacoes'] = consultant.contract.termination?consultant.contract.termination.observation:'-';
                format['Laptop_Devolvido'] = consultant.contract.termination?consultant.contract.termination.laptopReturned?'Sim':'Não':'-';
                format['Acordo_Devolucao'] = consultant.contract.termination?consultant.contract.termination.returnAgreement?'Sim':'Não':'-';
                format['Descricao_Acordo'] = consultant.contract.termination?consultant.contract.termination.descReturnAgreement?consultant.contract.termination.descReturnAgreement:'-':'-';
                format['Documento de saída gerado'] = consultant.contract.termination && consultant.contract.termination.type && consultant.contract.termination.generationDate ?
                this.commonHelper.transcriptOutputDocumentGenerated(this.commonHelper.transcriptTerminantionType(consultant.contract.termination.type),consultant.contract.termination.generationDate):'-';
                format['Historico_Clientes'] = consultant.contract.customers&&consultant.contract.customers.length>0?flatOldCustomers.join(' | '):'-';
                format['additive_history'] = this.outputAdditiveHistory && consultant.contract.additivesHistory ? consultant.contract.additivesHistory : [];
                format['contract_history'] = this.outputContractHistory && consultant.contractsHistory ? consultant.contractsHistory : [];
            }
        }

        return format;
    }

    addBorrowInvoiceNote(format, consultant){
        format['Nome_Emprestador_Nota'] = consultant.borrowInvoiceNote? consultant.borrowInvoiceNote.lenderName: "-"
        format['Data_Inicio_Nota'] = consultant.borrowInvoiceNote?moment(consultant.borrowInvoiceNote.start).utc().format("DD/MM/YYYY"): "-"
        format['Data_Fim_Nota'] = consultant.borrowInvoiceNote?moment(consultant.borrowInvoiceNote.end).utc().format("DD/MM/YYYY"):"-"

        return format
    }

    addPayment(format, consultant){
        format['Pagamento_Banco'] = (consultant.payment && consultant.payment.bank)?this.transcriptBank(consultant.payment.bank):'-';
        format['Pagamento_Agencia'] = (consultant.payment && consultant.payment.agency)?consultant.payment.agency:'-';
        format['Pagamento_Conta'] = (consultant.payment && consultant.payment.account)?consultant.payment.account:'-';
        format['Pagamento_Digito'] = (consultant.payment && consultant.payment.digit)?consultant.payment.digit:'-';
        format['Pagamento_Tipo_Pix'] = consultant.payment && consultant.payment.typePix?this.commonHelper.transcriptPixType(consultant.payment.typePix):'-';
        format['Pagamento_Chave_Pix'] = consultant.payment && consultant.payment.keyPix?consultant.payment.keyPix : '-';
        return format;
    }

    addContact(format,exportObject,consultant){
        format['Emergencia_Contato_Tipo'] = exportObject.contactType; // quem é o contato
        format['Emergencia_Contato_Nome'] = consultant.emergency.name? consultant.emergency.name:'-';
        format['Emergencia_Contato_Fone'] = consultant.emergency.phone? consultant.emergency.phone:'-';

        return format;
    }

    addInfraDatas(format,consultant){
        format['CPF'] = consultant.personal.cpf?consultant.personal.cpf:'-';
        format['Laptop_Devolvido'] = consultant.contract.termination?consultant.contract.termination.laptopReturned?'Sim':'Não':'-';
        format['Acordo_Devolucao'] = consultant.contract.termination?consultant.contract.termination.returnAgreement?'Sim':'Não':'-';
        format['Descricao_Acordo'] = consultant.contract.termination?consultant.contract.termination.descReturnAgreement?consultant.contract.termination.descReturnAgreement:'-':'-';
        format['Laptop_Com_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopReturned?consultant.contract.termination.laptopHasBreakdown?'Sim':'Não':'-';
        format['Valor_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopHasBreakdown?consultant.contract.termination.damageValue?consultant.contract.termination.damageValue:'-':'-';
        format['Descrição_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopHasBreakdown?consultant.contract.termination.damageValueObservation?consultant.contract.termination.damageValueObservation:'-':'-';
        return format;
    }

    setFormatControllership(format,consultant){
        format['Contrato_Inicio'] = consultant.contract.begin ?  moment(consultant.contract.begin).utc().format("DD/MM/YYYY"): "-";
        format['Contrato_Fim'] = consultant.contract.end ?  moment(consultant.contract.end).utc().format("DD/MM/YYYY"): "-";
        return format
    }

    addAdm2Datas(format, consultant){
        format['Telefone'] = consultant.personal.homePhone?consultant.personal.homePhone:'-';
        format['Celular'] = consultant.personal.cellPhone?consultant.personal.cellPhone:'-';
        format['Consultor_CEP'] = consultant.personal.cep?consultant.personal.cep:'-';
        format['Consultor_Endereco'] = consultant.personal.address?consultant.personal.address:'-';
        format['Consultor_Numero'] = consultant.personal.number?consultant.personal.number:'-';
        format['Consultor_Complemento'] = consultant.personal.complement?consultant.personal.complement:'-';
        format['Consultor_Bairro'] = consultant.personal.district?consultant.personal.district:'-';
        format['Consultor_Cidade'] = consultant.personal.city?consultant.personal.city:'-';
        format['Consultor_Estado'] = consultant.personal.state?consultant.personal.state:'-';
        return format;
    }

    addFinancesData(format, exportObject, consultant){
        format['Contrato_Tipo'] = exportObject.kind?exportObject.kind:"-";
        format['Alocacao'] = consultant.contract.allocation?this.commonHelper.transcriptAllocationType(consultant.contract.allocation):'-';
        format['Custo_Total_Provisões_e_Benefícios'] = consultant.contract.totalCostWithBenefits?consultant.contract.totalCostWithBenefits.toLocaleString("pt-BR"):'-'; //valor das horas vendidas
        format["Data_Saída"] = consultant.consultantEnd ? moment(consultant.consultantEnd).utc().format("DD/MM/YYYY") : "-";
        return format
    }

    addFinishedDocumentsData(format, consultant){
        const consultantDocs = this.docuSignDocuments.filter(docs => docs.consultant.consultantId == consultant._id);

        const documents = {} as any;
        const documentsTypes = this.commonHelper.getClicksignDocumentsTypes();
        documentsTypes.forEach(docType => {
            const docExists = consultantDocs.find(c => c.type === docType);
            documents[docType] = docExists ? docExists.signers : false;
        });

        if (!this.isUserGovernance) {
            format['Contrato assinaturas'] = documents.contract && documents.contract.length ?
                this.formatSigners(documents.contract) : '-';
            format['Termo de Confidencialidade assinaturas'] = documents.confidentialityTerm && documents.confidentialityTerm.length ?
                this.formatSigners(documents.confidentialityTerm) : '-';
            format['Renovado assinaturas'] = documents.renovation && documents.renovation.length ?
                this.formatSigners(documents.renovation) : '-';
            format['Reajuste assinaturas'] = documents.readjustment && documents.readjustment.length ?
                this.formatSigners(documents.readjustment) : '-';
            format['Alteração de CNPJ e Razão Social assinaturas'] = documents.changeCompany && documents.changeCompany.length ?
                this.formatSigners(documents.changeCompany) : '-';
        }
        format['Distrato/Quitação assinaturas'] = documents.distract && documents.distract.length ? this.formatSigners(documents.distract) :
            documents.discharge && documents.discharge.length ? this.formatSigners(documents.discharge) : '-';

        return format;
    }

    formatSigners(signers: Signer[]) {
        const types = {
            "party": "Parte",
            "witness": "Testemunha"
        };
        const transcriptSignerType = type => types[type];

        let orderedSigners = signers.sort((a, b) => {
            return (a.order < b.order) ? -1 : (a.order > b.order) ? 1 : 0;
        });

        const formatted = orderedSigners.map(signer => {
            return `${signer.order}º - ${signer.name} (${transcriptSignerType(signer.type)} - ${signer.signed ? 'Sim' : 'Não'})`;
        });

        return formatted.join(', ');
    }

    addAdditivesHistory(consultants) {
        let dataExport = [];
        consultants.forEach(consultant => {
            let isUserDPAndCLT = this.isUserDP && consultant['Contrato_Tipo'] != 'PJ';
            if(consultant.additive_history.length > 0) {
                dataExport.push(consultant);

                consultant.additive_history.forEach(additive => {
                    let additiveOld = {};

                    _.forOwn(consultant, (value, key) => {
                        additiveOld[key] = value;
                    });

                    if (this.canShow || isUserDPAndCLT) {
                        additiveOld['Aditivo_Situacao'] = 'Log do histórico de aditivos';
                        additiveOld['Aditivo_Tipo'] = additive.additiveType == '1' ? 'Reajuste de valor' :
                                                      additive.additiveType == '2' ? 'Renovação de contrato' :
                                                      additive.additiveType == '3' ? 'Alteração de Razão Social/CNPJ' : '###';
                        additiveOld['Aditivo_Pendente'] = additive.pendingApproval ? 'Sim' : 'Não';
                        additiveOld['Aditivo_Data'] = additive.date ? moment(additive.date).utc().format("DD/MM/YYYY") : '-';
                        additiveOld['Honorario'] = this.commonHelper.transcriptHonorariumType(additive.honorarium);
                        additiveOld['Total_Valor'] = additive.totalValue ? additive.totalValue.toLocaleString("pt-BR") : '-';
                        additiveOld['Horas_Mensais'] = additive.mensalHours ? additive.mensalHours.toLocaleString("pt-BR") : '-';
                        additiveOld['Valor_Horas_vendidas'] = additive.soldHourValue ? additive.soldHourValue.toLocaleString("pt-BR") : '-';
                        additiveOld['Valor_Hora'] = additive.hourValue ? additive.hourValue.toLocaleString("pt-BR") : '-';
                    }
                    additiveOld['Razao_Social'] = additive.oldCompanyName ? additive.oldCompanyName : '-' ;
                    additiveOld['CNPJ'] = additive.oldCnpj ? additive.oldCnpj : '-' ;
                    additiveOld['Empresa_CEP'] = additive.oldCompanyCep ? additive.oldCompanyCep : '-' ;
                    additiveOld['Empresa_Endereco'] = additive.oldCompanyAddress ? additive.oldCompanyAddress : '-' ;
                    additiveOld['Empresa_Numero'] = additive.oldCompanyNumber ? additive.oldCompanyNumber : '-' ;
                    additiveOld['Empresa_Bairro'] = additive.oldCompanyDistrict ? additive.oldCompanyDistrict : '-' ;
                    additiveOld['Empresa_Cidade'] = additive.oldCompanyCity ? additive.oldCompanyCity : '-' ;
                    additiveOld['Empresa_Estado'] = additive.oldCompanyState ? additive.oldCompanyState : '-' ;

                    //Mantém array de contratos apenas na 1º posição p/ evitar duplicidade Adt X Cont
                    additiveOld['contract_history'] = [];

                    delete additiveOld['additive_history'];

                    dataExport.push(additiveOld);
                });
                delete consultant.additive_history;
            } else {
                delete consultant.additive_history;
                dataExport.push(consultant);
            }
        });
        return dataExport;
    }

    addContactsHistory(consultants) {
        let dataExport = [];
        consultants.forEach(consultant => {
            if(consultant.contract_history.length > 0) {
                dataExport.push(consultant);

                consultant.contract_history.forEach(contract => {
                    let contractOld = {};

                    const flatCustomer = contract.customers && contract.customers.map((ch: CustomerType) => this.transcriptCustomerName(ch))
                        .filter((item: string) => typeof item === 'string');
                    const flatOldCustomers = contract.customers && contract.customers.map((ch: CustomerType) => this.transcriptCustomerHistory(ch))
                        .filter((item: string) => typeof item === 'string');
                    const flatManagerClient = contract.customers && contract.customers.map((ch: CustomerType) => this.transcriptManagerClient(ch))
                        .filter((item: string) => typeof item === 'string');
                    const flatOldManagerClient = contract.customers && contract.customers.map((ch: CustomerType) => this.transcriptOldManagerClient(ch))
                        .filter((item: string) => typeof item === 'string');

                    _.forOwn(consultant, (value, key) => {
                        contractOld[key] = value;
                    });

                    let isUserDPAndCLT = this.isUserDP && contract.kind != 1;
                    if (this.canShow || isUserDPAndCLT) {
                        contractOld['Contrato_Situacao'] = 'Log do histórico de contratos';
                        contractOld['Contrato_Inicio'] = contract.begin ? moment(contract.begin).utc().format("DD/MM/YYYY") : "-";
                        contractOld['Contrato_Fim'] = contract.end ? moment(contract.end).utc().format("DD/MM/YYYY") : "-";
                        contractOld['Honorario'] = this.canShow?contract.honorarium?this.commonHelper.transcriptHonorariumType(contract.honorarium):"-":'###'; // 1 = aberto / 2 = fechado
                        contractOld['Pagamento_Tipo'] = this.canShow?contract.paymentType?this.commonHelper.transcriptPaymentType(contract.paymentType):'-':'###';
                        contractOld['Total_Valor'] = this.canShow?contract.totalValue?contract.totalValue.toLocaleString("pt-BR"):'-':'###';
                        contractOld['Horas_Mensais'] = this.canShow?contract.mensalHours?contract.mensalHours.toLocaleString("pt-BR"):'-':'###'; // horas mensais de contrato
                        contractOld['Valor_Hora'] = this.canShow?contract.hourValue?contract.hourValue.toLocaleString("pt-BR"):'-':'###';
                        contractOld['Valor_Horas_vendidas'] = this.canShow?contract.soldHourValue?contract.soldHourValue.toLocaleString("pt-BR"):'-':'###'; //valor das horas vendidas
                        contractOld['Beneficios'] = this.canShow?contract.benefits?contract.benefits:'-':'###';
                        contractOld['Parceria_Contabil'] = contract.partnership ? this.commonHelper.transcriptPartnershipType(contract.partnership) : '-'; //rational, etc
                        contractOld['Parceria_Contabil_Obs'] = contract.partnershipObs?contract.partnershipObs:'-'; //comentarios
                        contractOld['Contrato_Status'] = contract.contractStatus ? this.commonHelper.transcriptContractStatus(contract.contractStatus) : '-';
                        contractOld['CPOM'] = contract.cpom?contract.cpom:'-';
                        contractOld['ISS'] = contract.iss?contract.iss:'-';
                        contractOld['IRRF'] = contract.irrf?contract.irrf:'-';
                        contractOld['PCC'] = contract.pcc?contract.pcc:'-';
                        contractOld['Contrato_Gerado'] = contract.generated?'Sim':'Não';
                        contractOld['Contrato_Nota'] = contract.borrowedNote?this.commonHelper.transcriptBorrowNote(parseInt(contract.borrowedNote)):'-';
                        contractOld['Alocacao'] = contract.allocation?this.commonHelper.transcriptAllocationType(contract.allocation):'-';
                        contractOld['Clientes'] = contract&&contract.customers.length>0?flatCustomer.join(' | '):'-';
                        contractOld['Gestor do Cliente - Histórico'] = contract&&contract.customers.length>0?flatOldManagerClient.join(' | '):'-';
                        contractOld['Gestor do Cliente - Atual'] = contract&&contract.customers.length>0?flatManagerClient.join(' | '):'-';
                        contractOld['Classificacao'] = contract.classification?this.commonHelper.transcriptContractClassification(contract.classification):'-';
                        contractOld['Contrato_Regime'] = contract.taxRegime?contract.taxRegime:'-';
                        contractOld['Motivo_Saida'] = contract.termination?this.commonHelper.transcriptLeaveType(contract.termination.leaveType):'-';
                        contractOld['Observacoes'] = contract.termination?contract.termination.observation:'-';
                        contractOld['Laptop_Devolvido'] = contract.termination && this.isUserInfra?contract.termination.laptopReturned?'Sim':'Não':'-';
                        contractOld['Acordo_Devolucao'] = contract.termination && this.isUserInfra?contract.termination.returnAgreement?'Sim':'Não':'-';
                        contractOld['Descricao_Acordo'] = contract.termination && this.isUserInfra?contract.termination.descReturnAgreement?contract.termination.descReturnAgreement:'-':'-';
                        contractOld['Documento de saída gerado'] = this.isUserInfra && consultant.contract.termination && consultant.contract.termination.type && consultant.contract.termination.generationDate ?
                            this.commonHelper.transcriptOutputDocumentGenerated(this.commonHelper.transcriptTerminantionType(consultant.contract.termination.type),consultant.contract.termination.generationDate):'-';
                        contractOld['Historico_Clientes'] = contract&&contract.customers.length>0?flatOldCustomers.join(' | '):'-';
                    }
                    contractOld['Razao_Social'] = contract.companyName?contract.companyName:'-';
                    contractOld['CNPJ'] = contract.cnpj?contract.cnpj:'-';
                    contractOld['Empresa_CEP'] = contract.cep?contract.cep:'-';
                    contractOld['Empresa_Endereco'] = contract.address?contract.address:'-';
                    contractOld['Empresa_Numero'] = contract.number?contract.number:'-';
                    contractOld['Empresa_Bairro'] = contract.district?contract.district:'-';
                    contractOld['Empresa_Cidade'] = contract.city?contract.city:'-';
                    contractOld['Empresa_Estado'] = contract.state?contract.state:'-';
                    contractOld['Cargo'] = contract.position?this.commonHelper.transcriptPositionType(contract.position):'-';
                    contractOld['Perfil'] = contract.occupation?(this.occupations.find(occ => occ.code == contract.occupation) || {}).name:'-';

                    if(this.outputAdditiveHistory && this.canShow)
                        contractOld['Aditivo_Situacao'] = 'Log de aditivo';

                    delete contractOld['contract_history'];

                    dataExport.push(contractOld);
                });
                delete consultant.contract_history;
            } else {
                delete consultant.contract_history;
                dataExport.push(consultant);
            }
        });
        return dataExport;
    }


    findOccupation(occupation: number) {
        if (occupation) {
            const foundOccupation = this.occupations.find(occ => occ.code == occupation);
            return foundOccupation != undefined ? foundOccupation.name : '-'
        }
        return '-'
    }

    transcriptBank(bankCode: string){
        const bank = this.banks.find(b => b.bankCode === bankCode);
        return bank ? bank.name : '';
    }

    setIndustryForTechManagement() {
        if(!this.user.industries || !this.user.industries.length) {
            this.toastr.warning("O usuário Tech Management não possui setor atribuído, contate o administrador");
            this.router.navigate(['home']);
        }

        const industriesIdsTechManagement = this.user.industries.map(i => i._id);
        const industriesFilter = this.filters.industry.list.filter(i => industriesIdsTechManagement.includes(i.id));
        this.filters.industry.list = [...industriesFilter];
        this.filters.industry.selected = [...industriesFilter];
        this.filters.industry.options = { ...this.filters.industry.options, disabled: true };
    }

    checkPermissions(){
        if(this.user.permission == GUARDS.INFRA)
            this.isUserInfra = true;
        else if(this.user.permission == GUARDS.ADMINISTRATIVE_2)
            this.isUserAdm2 = true;
        else if(this.user.permission == GUARDS.CONTROLLERSHIP)
            this.isUserControllership = true;
        else if(this.user.permission == GUARDS.GOVERNANCE)
            this.isUserGovernance = true;
        else if(this.user.permission == GUARDS.COMMERCIAL)
            this.isUserCommercial = true;
        else if(this.user.permission == GUARDS.DP)
            this.isUserDP = true;
        else if(this.user.permission == GUARDS.FINANCES)
            this.isUserFinances = true;
        else if(this.user.permission == GUARDS.JUDICIARY)
            this.isUserJudiciary = true;
        else if(this.user.permission == GUARDS.RS)
            this.isUserRS = true;
        else if(this.user.permission == GUARDS.BUSINESSPARTNER)
            this.isUserBP = true;
        else if(this.user.permission == GUARDS.ACCOUNTING)
            this.isUserAccounting = true;

        this.isUserPeople = this.user.permission == GUARDS.PEOPLE;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/reports/consultants-report/consultants-report.component.ts